import React, { useContext } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { FormErrorContext } from './FormErrorContext';
import _ from 'lodash';
import { MessagesContext } from '../messages/MessagesContext';


const PostalCode = (props) => {

    const { formErrors } = useContext(FormErrorContext);
    const { messages } = useContext(MessagesContext);

    let fieldError = undefined;
    let valstate = props.valstate;
    if (!_.isEmpty(formErrors)) {
        fieldError = formErrors[props.name];
        valstate = false;
    }

    const removeSpaces = (event) => {
        event.target.value = event.target.value.replaceAll(/\s/g, '');
        event.target.value = event.target.value.toUpperCase();
        return props.onChange(event);
    }

    return (
        <Form.Group controlId={props.name}>
            <Form.Label>{props.label}</Form.Label><span style={{
                fontSize: "12px",
                marginBottom: "5px",
                fontWeight: "400",
                color: "#9A9A9A",
            }}>&nbsp;
                {props.country === 'US' && "(e.g. 48126)"}
                {(!props.hasOwnProperty('country') || props.country === 'CA') && "e.g. L3R4X2"}</span>
            <InputGroup>
                <Form.Control
                    name={props.name}
                    type={props.type}
                    placeholder={props.placeholder}
                    value={props.value || ""}
                    style={{ backgroundColor: props.valstate ? "" : "pink" }}
                    onChange={removeSpaces}
                    onBlur={props.onBlur}
                    onKeyDown={props.onKeyDown}
                    isInvalid={!valstate}
                    readOnly={props.readOnly}
                    ref={props.rref}
                    className={props.className}
                />
                {!props.valstate && (<Form.Control.Feedback type="invalid">{props.valMsg}</Form.Control.Feedback>)}
                {fieldError && (<Form.Control.Feedback type="invalid">{fieldError}:{messages[fieldError]}</Form.Control.Feedback>)}
            </InputGroup>
        </Form.Group>

    );

}

export default PostalCode